import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, EditableDBItemV3, LL_H_C, LL_V_L, ModuleFE_AppConfig, ModuleFE_Dialog, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { ConfigKey_IndependentScores } from '@app/advisor-ui-shared';
import { ICONS } from '@app/styles';
import { dbObjectToId } from '@nu-art/ts-common';
import { ConfigKeyFE_Scores, DropDown_Variable, ModuleFE_Variable } from '@app/hcs-frontend';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import './ConfigDialog_IndependentScores.scss';
export class ConfigDialog_IndependentScores extends ComponentSync {
    // ######################## Static ########################
    static show() {
        const model = {
            dialogKey: ConfigKey_IndependentScores,
            closeOverlayOnClick: () => true,
            content: _jsx(ConfigDialog_IndependentScores, {}),
        };
        ModuleFE_Dialog.show(model);
    }
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable ??= this.getEditable();
        return state;
    }
    // ######################## Logic ########################
    getEditable() {
        const config = ModuleFE_AppConfig.cache.find(config => config.key === ConfigKey_IndependentScores) ?? { key: ConfigKey_IndependentScores, data: [] };
        // @ts-ignore
        const editable = new EditableDBItemV3(config, ModuleFE_AppConfig);
        editable.setAutoSave(true);
        editable.setOnChanged(async () => this.forceUpdate());
        editable.setOnSaveCompleted(() => this.forceUpdate());
        return editable;
    }
    closeDialog = () => {
        ModuleFE_Dialog.close();
    };
    getScoreVariableIds = () => {
        const scoreTagId = ConfigKeyFE_Scores.get();
        const existingIds = this.state.editable.item.data?.map(ref => ref.variableId) ?? [];
        return ModuleFE_Variable.cache.filter(variable => {
            if (existingIds.includes(variable._id))
                return false;
            return variable.tagIds.some(group => group.value.includes(scoreTagId));
        }).map(dbObjectToId);
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { id: 'config-dialog__independent-scores', className: 'config-dialog', children: [this.render_Title(), this.render_Content()] });
    }
    render_Title = () => {
        return _jsxs(LL_H_C, { className: 'config-dialog__title', children: ["Editor - Independent Scores", _jsx(ICONS.x.component, { className: 'config-dialog__title-icon', onClick: this.closeDialog })] });
    };
    render_Content = () => {
        const allowedVariableIds = this.getScoreVariableIds();
        const data = this.state.editable.editProp('data', []);
        return _jsxs(LL_H_C, { className: 'config-dialog__content', children: [data.item.map((ref, index) => {
                    const editable = data.editProp(index, {});
                    editable.setOnDelete(() => data.removeArrayItem(index));
                    return _jsxs(LL_V_L, { className: 'score-reference-editor', children: [_jsx(ICONS.bin.component, { onClick: () => editable.delete() }), _jsx(TS_PropRenderer.Vertical, { label: 'Score Variable', children: _jsx(DropDown_Variable, { selected: editable.item?.variableId, queryFilter: variable => allowedVariableIds.includes(variable._id), sortBy: ['name'], limitItems: 50, onSelected: variable => editable.update('variableId', variable._id) }) }), _jsx(TS_PropRenderer.Vertical, { label: 'MD Calc URL', children: _jsx(DefaultEditor_InputText, { editable: editable, prop: 'mdCalcUrl' }) })] }, ref?.variableId);
                }), _jsx(DropDown_Variable, { selected: undefined, queryFilter: variable => allowedVariableIds.includes(variable._id), sortBy: ['name'], limitItems: 50, placeholder: 'Add New Score', onSelected: variable => {
                        data.updateArrayAt({ variableId: variable._id, mdCalcUrl: '' });
                    } })] });
    };
}
//# sourceMappingURL=ConfigDialog_IndependentScores.js.map